<div class="mtlr-3" style="display:flex;flex-direction: column;">
    <div>
        <app-bulk-export-toolbox (buttonAction)="onButtonAction($event)"></app-bulk-export-toolbox>
    </div>
    <div style="width: 100%;height: calc(100vh - 245px);margin-top: 10px;">
        <app-formly-bulk-export-view></app-formly-bulk-export-view>
    </div>
</div>
